// extracted by mini-css-extract-plugin
module.exports = {"mouse":"ScrollIndicator_mouse__3POdW","border":"ScrollIndicator_border__2Hgaq","blink":"ScrollIndicator_blink__k1woc","scroll":"ScrollIndicator_scroll__UU6Yh"};